import React from 'react';
import YesNoButtons from './YesNoButtons';
import ChoiceButtons from './ChoiceButtons';

const isYesNoActions = actions => {
  if (!actions || actions.length !== 2) return false;

  const values = actions.map(a => a.value.toLowerCase());
  return values.includes('yes') && values.includes('no');
};

const ActionButtons = ({ activity }) => {
  if (!activity || !activity.suggestedActions || !activity.suggestedActions.actions) {
    return null;
  }

  const actions = activity.suggestedActions.actions;

  if (isYesNoActions(actions)) {
    return <YesNoButtons activity={activity} />;
  }

  return <ChoiceButtons activity={activity} />;
};

export default ActionButtons;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/ActionButtons/index.js